import React, { PureComponent } from 'react';
import moment from 'moment-timezone';

// Styles
import styles, { Container, Inner, List, Item, Circle, DateText, Text } from './styles';
/*

activities: [
  {
        "category": "ASSIGNMENT",
        "type": "PLANNING",
        "action": "book",
        "ts": 1576487829621,
        "assignment_label": "AC",
        "assignment_id": 184765
  }
]
*/
export default class ActivityDriver extends PureComponent {
  getActivity(action, assignLabel, assignId) {
    if (action === 'book') {
      return `Driver booked assignment ${assignLabel} (${assignId})`;
    } else if (action === 'un-book') {
      return `Driver un-booked assignment ${assignLabel} (${assignId})`;
    }

    return `Unknown action on assignment ${assignLabel} (${assignId})`;
  }

  render() {
    const { action } = styles;
    let events = this.props.activities || [];

    return (
      <Container>
        <Inner>
          <List>
            {events.map((h, i) => {
              return (
                <Item key={`event-${h.ts}-${i}`}>
                  <Circle style={{ backgroundColor: action[h.action] }} />
                  <Text>{this.getActivity(h.action, h.assignment_label, h.assignment_id)}</Text>
                  <DateText>{moment(h.ts).format('dddd M/D/YYYY - hh:mm:ss a')}</DateText>
                </Item>
              );
            })}
          </List>
        </Inner>
      </Container>
    );
  }
}
